import { print } from 'graphql';
import Vue from 'vue';
import api from './repository';
import SEARCH_CONTRACTS_QUERY from './queries/contract/search';
import RECENTLY_OPENED_CONTRACTS_QUERY from './queries/contract/recentlyOpened';
import CONTRACT_DETAILS_QUERY from './queries/contract/details';
import UPDATE_CONTRACT_MUTATION from './queries/contract/update';
import DELETE_CONTRACT_MUTATION from './queries/contract/delete';
import CREATE_CONTRACT_MUTATION from './queries/contract/create';

export default {
  async searchContracts(fields, searchValue) {
    try {
      const response = await api.post('/graphql/', {
        query: print(SEARCH_CONTRACTS_QUERY),
        variables: { fields, searchValue },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async getRecentlyOpenedContracts() {
    try {
      const response = await api.post('/graphql/', {
        query: print(RECENTLY_OPENED_CONTRACTS_QUERY),
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async getContractDetails(contractId) {
    try {
      const response = await api.post('/graphql/', {
        query: print(CONTRACT_DETAILS_QUERY),
        variables: { contractId },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async updateContract(contract) {
    try {
      const response = await api.post('/graphql/', {
        query: print(UPDATE_CONTRACT_MUTATION),
        variables: {
          contractId: contract.contractId,
          futureValuePremiumFreeFiscal: contract.futureValuePremiumFreeFiscal,
          futureValuePremiumPayingFiscal: contract.futureValuePremiumPayingFiscal,
          situationDate: Vue.moment(contract.situationDate).format('YYYY-MM-DD'),
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async deleteContract(contractId) {
    try {
      const response = await api.post('/graphql/', {
        query: print(DELETE_CONTRACT_MUTATION),
        variables: { contractId },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
  async createContract(primaryContractId, contract) {
    try {
      const response = await api.post('/graphql/', {
        query: print(CREATE_CONTRACT_MUTATION),
        variables: {
          mainContractId: primaryContractId,
          contractTypeId: contract.contractTypeId,
          contractNumber: contract.contractNumber,
          insuranceCompanyName: contract.insuranceCompanyName,
          endAge: contract.endAge,
          futureValuePremiumFreeFiscal: contract.futureValuePremiumFreeFiscal,
          futureValuePremiumPayingFiscal: contract.futureValuePremiumPayingFiscal,
          customerId: contract.customerId,
        },
      });
      return response;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
    return null;
  },
};
